import { Module } from './base';
import { getTranslation } from "../components/i18n";
import SettingsPersistor from "../components/settings-persistor";

class EnlargedButtonsModule implements Module {
  name = 'enlarged-buttons';

  setup(a11ySettings: Record<string, any>, modulesContainer: HTMLElement) {
    const moduleName = this.name;
    let styleContents = `
      .a11y-button-enlarged button, .a11y-button-enlarged a, .a11y-button-enlarged select, .a11y-button-enlarged input {
        font-size: 120% !important;
      }
      .a11y-button-enlarged input[type="checkbox"], .a11y-button-enlarged input[type="radio"] {
        scale: 1.25 !important;
      }
    `;
    const enlargedButtonsElement = document.createElement("div");
    enlargedButtonsElement.className = `a11y-module a11y-module-${moduleName}`;
    enlargedButtonsElement.innerHTML = `
      <label id="a11y-${moduleName}-label" for="toggle-${moduleName}" data-translation-field="true" data-translation-key="enlargedButtons">${getTranslation('enlargedButtons')}</label>
      <label class="a11y-toggle" tabindex="0" aria-labelledby="a11y-${moduleName}-label a11y-${moduleName}-label-text">
        <span id="a11y-${moduleName}-label-text" class="screen-reader-text">Die Option ist <span class="toggle-state-text"></span></span>
        <input id="toggle-${moduleName}" type="checkbox" tabindex="-1">
        <span class="slider"></span>
      </label>
    `;
    modulesContainer.appendChild(enlargedButtonsElement);
    const enlargedButtonsToggle = document.getElementById(`toggle-${moduleName}`) as HTMLInputElement;
    const toggleStateText = enlargedButtonsElement.querySelector(`.toggle-state-text`) as HTMLSpanElement;
    enlargedButtonsToggle.addEventListener("click", () => {
      toggleStateText.innerText = enlargedButtonsToggle.checked ? 'aktiviert' : 'deaktiviert';
      document.body.classList.toggle("a11y-button-enlarged", enlargedButtonsToggle.checked);
      SettingsPersistor.save(moduleName, enlargedButtonsToggle.checked);
    });
    toggleStateText.innerText = a11ySettings[moduleName] ? 'aktiviert' : 'deaktiviert';
    if (a11ySettings[moduleName]) {
      enlargedButtonsToggle.checked = a11ySettings[moduleName];
      document.body.classList.toggle("a11y-button-enlarged", enlargedButtonsToggle.checked);
    }
    return styleContents;
  }

  reset() {
    const toggle = document.getElementById('toggle-enlarged-buttons') as HTMLInputElement;
    if (toggle) {
      toggle.checked = false;
      toggle.dispatchEvent(new Event('click'));
    }
    document.body.classList.remove('a11y-button-enlarged');
  }
}

export default new EnlargedButtonsModule();